import moment from 'moment';
import { CONTRATO_STATUS_EM_ANALISE } from '../../library/ContratoStatus';
import { CONTRATO_TIPO_ENTE_PUBLICO } from '../../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
} from '../../library/ContratoVersoes';
import { toRequest } from '../../utils/RequestUtils';
import { getApis } from './../../library/Apis';
import { contratoAlteraStatus, loadContratoArquivos } from './ContratosActions';

export const CLEARED_CONTRATO_ENTE_PUBLICO_ACTION =
  'CLEARED_CONTRATO_ENTE_PUBLICO_ACTION';
export const LOADED_CONTRATO_ENTE_PUBLICO_ACTION =
  'LOADED_CONTRATO_ENTE_PUBLICO_ACTION';
export const CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION =
  'CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION';
export const LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL =
  'LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL';
export const LOADED_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL =
  'LOADED_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL';
export const LOADING_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION =
  'LOADING_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION';
export const LOADED_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION =
  'LOADED_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION';
export const CHANGED_CONTRATO_ENTE_PUBLICO_FLG_EDITING_VALUE_ACTION =
  'CHANGED_CONTRATO_ENTE_PUBLICO_FLG_EDITING_VALUE_ACTION'

export const LOADING_CONTRATO_ENTE_PUBLICO_ARQUIVOS =
  'LOADING_CONTRATO_ENTE_PUBLICO_ARQUIVOS';
export const LOADED_CONTRATO_ENTE_PUBLICO_ARQUIVOS =
  'LOADED_CONTRATO_ENTE_PUBLICO_ARQUIVOS';

const getEndpoint = (version) => {
  return getApis().apis.contrato + 'v' + version;
};

export const clearContratoEntePublicoEditing = () => ({
  type: CLEARED_CONTRATO_ENTE_PUBLICO_ACTION,
  payload: null,
});

export const changeAnaliseJuridicaValue = (name, value) => {
  return {
    type: CHANGED_CONTRATO_ENTE_PUBLICO_FLG_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const loadContratoEntePublico = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'get',
      [`${getEndpoint(1)}/contrato/ente-publico/${id}/${versaoContrato}`],
      'contratoEntePublico'
    ).then(
      (resp) => {
        let data = resp.data;
        data.ativo = data.flgAtivo;
        delete data.flgAtivo;
        data.dataInicio =
          data.dataInicio && data.dataInicio.length > 0
            ? moment(data.dataInicio, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataFim =
          data.dataFim && data.dataFim.length > 0
            ? moment(data.dataFim, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        data.dataDistrato =
          data.dataDistrato && data.dataDistrato.length > 0
            ? moment(data.dataDistrato, 'YYYY MM DD').format('DD-MM-YYYY')
            : '';
        dispatch(clearContratoEntePublicoEditing());
        dispatch({
          type: LOADED_CONTRATO_ENTE_PUBLICO_ACTION,
          payload: data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const changeContratoEntePublicoEditingValue = (name, value) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      if (typeof value === 'string') {
        if (value.trim().length > 0) {
          dispatch({
            type: CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
            payload: { name, value },
          });
          resolve();
        } else {
          dispatch({
            type: CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
            payload: { name, value: '' },
          });
          resolve();
        }
      }
      dispatch({
        type: CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
        payload: { name, value },
      });
      resolve();
    });
  };
};

export const loadHistoricoContratoEntePublicoAnaliseOperacional = (
  idContrato,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
      payload: true,
    });
    toRequest(
      'get',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/analise-operacional/revisoes/${idContrato}/${versaoContrato}`,
      ],
      'listaAnaliseOperacional'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoRegisterContrato = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    codCoop: contrato.codCoop,
    dataInicio: moment(contrato.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(contrato.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: contrato.emailCoop,
    idEstado: contrato.idEstado,
    nomCidade: contrato.nomCidade,
    totalMeses: contrato.totalMeses,
    flgAnaliseJuridica: contrato.flgAnaliseJuridica,
  };
  return (dispatch) => {
    toRequest(
      'post',
      [`${getEndpoint(1)}/contrato/ente-publico`, data],
      'save'
    ).then(
      (resp) => {
        dispatch(
          changeContratoEntePublicoEditingValue('idContrato', resp.data.id)
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoEditContrato = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    codCoop: contrato.codCoop,
    dataInicio: moment(contrato.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(contrato.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: contrato.emailCoop,
    idEstado: contrato.idEstado,
    nomCidade: contrato.nomCidade,
    totalMeses: contrato.totalMeses,
  };
  return () => {
    toRequest(
      'put',
      [`${getEndpoint(1)}/contrato/ente-publico/${contrato.idContrato}`, data],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoRegisterAditivo = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    codCoop: contrato.codCoop, 
    dataInicio: moment(contrato.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(contrato.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: contrato.emailCoop, 
    idContrato: contrato.idContrato,
    idEstado: contrato.idEstado,
    nomCidade: contrato.nomCidade, 
    tipoContrato: CONTRATO_TIPO_ENTE_PUBLICO,
    totalMeses: contrato.totalMeses,
    versaoContrato: CONTRATO_VERSAO_ADITIVO,
  };
  return (dispatch) => {
    toRequest(
      'post',
      [`${getEndpoint(1)}/contrato/ente-publico/aditivo`, data],
      'save'
    ).then(
      (resp) => {
        dispatch(
          changeContratoEntePublicoEditingValue('idAditivo', resp.data.id)
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoEditAditivo = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    dataInicio: moment(contrato.dataInicio, 'DD MM YYYY').format('YYYY-MM-DD'),
    dataFim: moment(contrato.dataFim, 'DD MM YYYY').format('YYYY-MM-DD'),
    emailCoop: contrato.emailCoop, 
    idContrato: contrato.idContrato,
    totalMeses: contrato.totalMeses,
    versaoContrato: CONTRATO_VERSAO_ADITIVO,
  };
  return () => {
    toRequest(
      'put',
      [
        `${getEndpoint(1)}/contrato/ente-publico/aditivo/${contrato.idAditivo}`,
        data,
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoRegisterDistrato = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    dataDistrato: moment(contrato.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
    idContrato: contrato.idContrato,
  };
  return (dispatch) => {
    toRequest(
      'post',
      [`${getEndpoint(1)}/contrato/ente-publico/distrato`, data],
      'save'
    ).then(
      (resp) => {
        dispatch(
          changeContratoEntePublicoEditingValue('idDistrato', resp.data.id)
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const contratoEntePublicoEditDistrato = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  const data = {
    dataDistrato: moment(contrato.dataDistrato, 'DD MM YYYY').format('YYYY-MM-DD'),
    idContrato: contrato.idContrato,
  };
  return () => {
    toRequest(
      'put',
      [
        `${getEndpoint(1)}/contrato/ente-publico/distrato/${contrato.idDistrato
        }`,
        data,
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePublicoRegisterPreEtapa = (
  contrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    switch (contrato.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        if (contrato.idAditivo) {
          dispatch(
            contratoEntePublicoEditAditivo(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        } else {
          dispatch(
            contratoEntePublicoRegisterAditivo(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        }
        break;
      case CONTRATO_VERSAO_DISTRATO:
        if (contrato.idDistrato) {
          dispatch(
            contratoEntePublicoEditDistrato(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        } else {
          dispatch(
            contratoEntePublicoRegisterDistrato(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        }
        break;
      default:
        if (contrato.idContrato) {
          dispatch(
            contratoEntePublicoEditContrato(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        } else {
          dispatch(
            contratoEntePublicoRegisterContrato(
              contrato,
              callbackSuccess,
              callbackError
            )
          );
        }
        break;
    }
  };
};

export const contratoEntePublicoSendAnaliseOperacional = (
  idContrato,
  comentario,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'post',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/analise-operacional/envio/${idContrato}`,
        {
          comentario,
          versaoContrato,
        },
      ],
      'save'
    ).then(
      () => {
        dispatch(
          changeContratoEntePublicoEditingValue(
            'flgStatus',
            CONTRATO_STATUS_EM_ANALISE
          )
        );
        dispatch(
          loadHistoricoContratoEntePublicoAnaliseOperacional(
            idContrato,
            versaoContrato
          )
        );
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePublicoReturnAnaliseOperacional = (
  params,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    const idContrato = params.idContrato;
    let formData = new FormData();
    formData.append('comentario', params.comentario);
    formData.append('acaoAvalia', params.acaoAvalia);
    formData.append('flgFilePrincipal', params.flgFilePrincipal);
    formData.append('versaoContrato', params.versaoContrato);
    formData.append('file', params.file);
    toRequest(
      'post',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/analise-operacional/retorno/documento/${idContrato}`,
        formData,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            if (typeof callbackProgress === 'function') {
              const percent = loaded / total;
              callbackProgress(percent);
            }
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePublicoiniciarProcessoAssinatura = (
  idContrato,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return () => {
    toRequest(
      'post',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/processo-assinatura/${idContrato}/${versaoContrato}`,
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const uploadNaoAssinadoContratoEntePublico = (
  params,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    const idContrato = params.idContrato;
    let formData = new FormData();
    formData.append('flgFilePrincipal', params.flgFilePrincipal);
    formData.append('versaoContrato', params.versaoContrato);
    formData.append('file', params.file);
    toRequest(
      'post',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/analise-operacional/envio/documento/${idContrato}`,
        formData,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            if (typeof callbackProgress === 'function') {
              const percent = loaded / total;
              callbackProgress(percent);
            }
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const uploadNaoAssinadoPlanoTrabalhoEntePublico = (
  params,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return () => {
    const idContrato = params.idContrato;
    let formData = new FormData();
    formData.append('flgFilePrincipal', params.flgFilePrincipal);
    formData.append('versaoContrato', params.versaoContrato);
    formData.append('file', params.file);
    toRequest(
      'post',
      [
        `${getEndpoint(
          1
        )}/contrato/ente-publico/analise-operacional/envio/plano/${idContrato}`,
        formData,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            if (typeof callbackProgress === 'function') {
              const percent = loaded / total;
              callbackProgress(percent);
            }
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const contratoEntePublicoAlteraStatus = (
  id,
  versaoContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      contratoAlteraStatus(
        id,
        versaoContrato,
        LOADING_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION,
        LOADED_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION,
        callbackSuccess,
        callbackError
      )
    );
  };
};

export const uploadExtratoContratoEntePublico = (
  file,
  id,
  versaoContrato,
  callbackSuccess,
  callbackError,
  callbackProgress
) => {
  return () => {
    const VERSAO_CONTRATO_ID = '#versaoContrato#';
    let url = `${getEndpoint(
      1
    )}/documento/extrato/${VERSAO_CONTRATO_ID}/${id}`;
    switch (versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_ADITIVO_NAME);
        break;
      case CONTRATO_VERSAO_DISTRATO:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_DISTRATO_NAME);
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_CONTRATO_NAME);
        break;
    }
    let data = new FormData();
    data.append('file', file);
    toRequest(
      'post',
      [
        url,
        data,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            const percent = loaded / total;
            callbackProgress({ percent }, file);
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        callbackSuccess(resp, file);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const uploadPlanoTrabalhoContratoEntePublico = (
  file,
  id,
  versaoContrato,
  callbackSuccess,
  callbackError,
  callbackProgress
) => {
  return () => {
    const VERSAO_CONTRATO_ID = '#versaoContrato#';
    let url = `${getEndpoint(
      1
    )}/documento/plano-trabalho/${VERSAO_CONTRATO_ID}/${id}`;
    switch (versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_ADITIVO_NAME);
        break;
      case CONTRATO_VERSAO_DISTRATO:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_DISTRATO_NAME);
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        url = url.split(VERSAO_CONTRATO_ID).join(CONTRATO_VERSAO_CONTRATO_NAME);
        break;
    }
    let data = new FormData();
    data.append('file', file);
    toRequest(
      'post',
      [
        url,
        data,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            const percent = loaded / total;
            callbackProgress({ percent }, file);
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        callbackSuccess(resp, file);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadContratoEntePublicoArquivos = (
  idContrato,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch(
      loadContratoArquivos(
        idContrato,
        LOADING_CONTRATO_ENTE_PUBLICO_ARQUIVOS,
        LOADED_CONTRATO_ENTE_PUBLICO_ARQUIVOS,
        callbackSuccess,
        callbackError
      )
    );
  };
};
